import { t } from "@lingui/core/macro";
import React from "react";
import Link from "next/link";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Meta from "../Meta";
import { Trans } from "@lingui/react/macro";

export default function Page404({ context }) {
    const { org } = context;

    return (
        <div className="travel-page travel-page--404">
            <Meta
                context={context}
                title="404"
                description={t`Page introuvable`}
            />
            <Header context={context} />

            <main className="travel-404">
                <div className="travel-404__container">
                    <h1 className="travel-404__code">404</h1>
                    <h2 className="travel-404__title">
                        <Trans>Page introuvable</Trans>
                    </h2>
                    <p className="travel-404__text">
                        <Trans>La page que vous recherchez n'existe pas ou a été déplacée.</Trans>
                    </p>
                    <Link href={org.BASE_WEB_URL} legacyBehavior>
                        <a className="travel-404__btn" style={{color:"#FFF"}}><Trans>Retour à l'accueil</Trans></a>
                    </Link>
                </div>
            </main>

            <Footer context={context} />
        </div>
    );
}
